import type { ActionApi } from '../../common/types.tsx';

export const fetchCdm =
	(): ActionApi =>
	async ({ setState, getState }) => {
		// eslint-disable-next-line no-console
		console.log('fetchCdm action called');

		// First reset state to undefined to indicate loading
		const initialState = getState();
		setState({
			...initialState,
			cdm: {
				...initialState.cdm,
				instantiations: undefined, // Reset to undefined while loading
			},
		});

		// Mock API calls - returning empty arrays for now
		const [instantiationsResponse, tasksResponse] = await Promise.all([
			// TODO: Replace with actual endpoint calls
			// performCmdbGetRequest('/v1/bundle/instantiated/list'),
			// performCmdbGetRequest('/v1/tasks'),
			Promise.resolve([]), // Mock empty instantiations
			Promise.resolve([]), // Mock empty tasks
		]);

		const state = getState();

		// Update CDM state with fetched data
		setState({
			...state,
			cdm: {
				instantiations: instantiationsResponse,
				tasks: tasksResponse,
			},
		});
	};
